<script setup>
import { useScroll } from '@vueuse/core'
import { watchEffect } from 'vue';
import DetailHot from './components/DetailHot.vue'
import Evaluate from './components/EvaluateView.vue'
import loginView from '@/components/loginView/index.vue'
import { maskName, exchangeRate } from '@/utils/index'
import ProductDetails from './components/ProductDetails.vue'
import { useMeta } from 'vue-meta';
import { useHead } from '@vueuse/head';
import { getDetail, setCollectApi, setDelCollectApi, setAddfollowApi, setDelfollowApi } from '@/apis/detail'
import { useRoute } from 'vue-router'
import routers from '@/router';

import { useCartStore } from '@/stores/cartStore'
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
let router = useRoute()
const slideCarousel = ref(null);
const scrollHeight = ref(0);
const windowHeight = ref(0);
const commodityElement = ref(null);
const commodityHeight = ref(0)
const goodsElement = ref(null);
const goodsHeight = ref(0)
const specElement = ref(null);
const specHeight = ref(0)
const specWidth = ref(0)

const specLeft = ref(0)

const userStore = useUserStore()
const cartStore = useCartStore()

const loginModel = ref(false);
const goods = ref({
})
const num = ref(1)
const detailId = ref(router.params.id)
const userId = ref(userStore.userInfo.id)
const mateTitle = ref();
const languages = ref()
const videoElement = ref()
const imageListData = ref()
const inventory = ref()//商品库存
const getGoods = async () => {
   
    let language = localStorage.getItem('language');
    if (language == 'zh-cn') {
        language = 'zn'
    }
    languages.value = language.toLowerCase()
    let dataParam={ id: detailId.value, userId: userId.value }
    if(router.query.type=="console"){
        console.log('router',router.query.type)
        dataParam.isAdmin=1
    }
    const res = await getDetail(dataParam)
    try {
        if (res.code == 0) {
            goods.value = res.data.data
            mateTitle.value = goods.value.name + ""
            imageListData.value = JSON.parse(JSON.stringify(goods.value.images))
            if (goods.value.video != '') {
                imageListData.value.unshift(goods.value.video)

            }
            // 尝试在组件挂载后播放视频
            if (videoElement.value) {
                console.log('视频播放')
                videoElement.value.play().catch(error => {
                    console.error('自动播放失败:', error);
                });
            }
            if (goods.value?.variableAttr?.length == 0) {//单规格

                goods.value.price = goods.value?.skus[0].price
                maxNum.value = goods.value?.skus[0].quantity
                skuId.value = goods.value?.skus[0].id
                skuData.value = goods.value?.skus[0].sku
                checkedCount.value = []
                inventory.value = goods.value?.skus[0].quantity
                console.log('单规格', goods.value?.skus[0].quantity)
            } else {
                console.log('其他库存', goods.value?.inventory)
                inventory.value = goods.value?.inventory || 0
            }

            // 过滤出quantity等于0的产品，并获取variant_names
            const filteredVariantNames = goods.value?.skus
                .filter(product => product.quantity === 0)
                .map(product => product.variant_names);

            console.log('等于0的产品', filteredVariantNames);
             // 过滤出quantity不等于0的产品，并获取variant_names
             const nofilteredVariantNames = goods.value?.skus
                .filter(product => product.quantity != 0)
                .map(product => product.variant_names);
                console.log('不等于0的产品',nofilteredVariantNames)
            // 使用reduce方法展平数组，并使用Set过滤重复值
            const uniqueVariantNames = nofilteredVariantNames.reduce((acc, current) => {
                return acc.concat(current);
            }, []).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            console.log('过滤重复值',uniqueVariantNames)
            console.log('数据',goods.value?.variableAttr)
            // 遍历attributes数组
            goods.value?.variableAttr.forEach(attr => {
                // 遍历每个属性的values数组
                attr.values.forEach(val => {
                    // 检查当前值是否在valuesToDisable数组中
                    if (uniqueVariantNames.includes(val.name.zn)) {
                        // 否则，设置isDisabled为false或删除该属性
                        val.isDisabled = false;
                    } else {
                       
                         // 设置isDisabled为true
                         val.isDisabled = true;
                    }
                });
            });
            console.log('商品数据',goods.value?.variableAttr)
            getHeight()
        } else if (res.code == 500) {//去商铺
            console.log('1111111')
            // goUser('46')

        } else {
            console.log('22222')
            ElMessage({ type: 'error', message: res.message })
        }
    } catch (error) {
        console.log('33333')
    }


}
const slideBanner = () => {
    //选中的轮播图
    let box = document.querySelector('.el-carousel__container');
    let startPoint = 0;
    let stopPoint = 0;
    //重置坐标
    let resetPoint = ()=>{
        startPoint = 0;
        stopPoint = 0;
    }
    //手指按下
    box.addEventListener("touchstart", (e)=>{
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
        console.log('slideCarousel',slideCarousel.value)
    });
    //手指滑动
    box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
    });
    //当手指抬起的时候，判断图片滚动离左右的距离
    let that = this
    box.addEventListener("touchend", function (e) {
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
            resetPoint();
            return;
        }
        if (startPoint - stopPoint > 0) {
            resetPoint();
            slideCarousel.value.next();
            return;
        }
        if (startPoint - stopPoint < 0) {
            resetPoint();
            slideCarousel.value.prev();
            return;
        }
    });
}
const getHeight = () => {
    try {
        if (commodityElement.value) {
        commodityHeight.value = commodityElement.value.offsetHeight;

    }
    if (goodsElement.value) {
        goodsHeight.value = goodsElement.value.offsetHeight;

    }
    if (specElement.value) {
        let child = document.querySelector('#specElement');
        console.log('child', child.getBoundingClientRect().left)
        specHeight.value = specElement.value.offsetHeight;
        if(specWidth.value<1){

            specWidth.value = specElement.value.offsetWidth;
            console.log('specElement.value.offsetWidth  ', specElement.value.offsetWidth  )
        }
        specLeft.value = child.getBoundingClientRect().left;
    }

    } catch (error) {
        console.log('err',error)
    }
}
/**
 * 
 * @param id 收藏
 */
const setCollect = async (id) => {
    if (userStore.userInfo.token) {
        const res = await setCollectApi({ productId: id })
        if (res.code == 0) {
            goods.value.isCollection = 2
            ElMessage({ type: 'success', message: t('home30') })
            userStore.getUser()
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
/**
 * 
 * @param id 取消收藏
 */
const setDelCollect = async (id) => {
    const res = await setDelCollectApi({ productId: id })
    if (res.code == 0) {
        goods.value.isCollection = 1
        ElMessage({ type: 'success', message: t('home31') })
        userStore.getUser()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 
 * @param value 取消关注
 */
const delfollow = (id) => {
    ElMessageBox.confirm(
        t('home32'),
        {
            cancelButtonText: t('home5'),
            confirmButtonText: t('home4'),
            type: 'warning',
        }
    )
        .then(async () => {
            const res = await setDelfollowApi({ followId: id })
            if (res.code == 0) {

                ElMessage({ type: 'success', message: t('home41') })
                userStore.getUser()
                goods.value.isFollow = 1
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: t('home33'),
            })
        })

}
/**
 * 
 * @param value 关注
 */
const Addfollow = async (id) => {
    if (userStore.userInfo.token) {
        const res = await setAddfollowApi({ followId: id })
        if (res.code == 0) {
            ElMessage({ type: 'success', message: t('home34') })
            userStore.getUser()
            goods.value.isFollow = 2
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }


}
const handleClose = () => {
    loginModel.value = false
    window.location.reload();
}

const skuId = ref()//skuid
const skuData = ref()//sku值
const properties_name = ref()
const maxNum = ref()
// 添加购物车
const addCart = () => {
    if (userStore.userInfo.token) {
        console.log(111)
        // if (skuObj.skuId) {
        // 规则已经选择 触发action
        if (goods.value.variableAttr?.length == checkedCount.value?.length) {
            cartStore.addCart({
                // shop_user_id: goods.value.userId,
                id: goods.value.id, // 商品id
                // name: goods.value.name, // 商品名称
                // picture: goods.value.coverUrl, // 图片
                // price: goods.value.price, // 最新价格
                // needIntlPostage:goods.value.needIntlPostage,//需要国际邮费
                // description: goods.description, // 商品规格文本
                // selected: true, // 商品是否选中
                // inventory: inventory.value,//商品库存
                num: num.value,//数量
                // from: 'product',
                source: '',//商品来源
                // sku: skuData.value,
                edit:false,
                sku_info: {//sku数据
                    sku_id: skuId.value,
                    properties_name: properties_name.value
                }
            })
            ElMessage({ type: 'success', message: t('setup12') })
            ProductInfoDrawer.value=false
        }

        // } else {
        //     // 规则没有选择 提示用户
        //     ElMessage.warning('请选择规格')
        // }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}
// 立即购买
const BuyitNowCart = () => {
    localStorage.removeItem('thirdData');
    if (userStore.userInfo.token) {
        let data = []
        let listitem = {
            selected: true,
            id: goods.value.id,
            name: goods.value.name,
            description: goods.value.description,
            price: goods.value.price,
            needIntlPostage:goods.value.needIntlPostage,
            quantity: num.value,
            belong_user_id: goods.value.userId,
            belong_user: goods.value.username,
            cover_url: goods.value.images[0],
            status: goods.value.status,
            total_price: null,
            sku_id:skuId.value,
            sku_name:properties_name.value,
            // sku_info: {
            //     sku_id: skuData.value,
            //     properties_name: properties_name.value
            // }

        }
        let item = {
            type: 1,
            shop_user: goods.value.username,
            shop_user_id: goods.value.userId,
            avatar: goods.value.avatar,
            list: [listitem],
            // sku: listitem.sku_info,
        }
        console.log(goods.value.variableAttr, checkedCount.value?.length)
        if (goods.value.variableAttr?.length == checkedCount.value?.length) {
            data.push(item)
            console.log(data)
            localStorage.setItem('order', JSON.stringify(data))
            routers.push('/checkout')
        }
    } else {
        // 2. 跳转到登录页
        loginModel.value = true
    }
}

const goUser = (id) => {
    // routers.push('/userDetails/' + id)
}
const isMobile = ref(false)
onMounted(async () => {

    // npm install vue-meta@3.0.0-alpha.7
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);


    if (userStore.userInfo.token) {
        userStore.getUser()
        userId.value = userStore.userInfo.id
    }
    getGoods()
    localStorage.setItem('order', '')
    // window.addEventListener('resize', ()=>{
    //     windowHeight.value = window.innerHeight;
    // })
    window.addEventListener('scroll', () => {
        scrollHeight.value = window.scrollY; // 或者使用 document.documentElement.scrollTop 或 document.body.scrollTop;
        windowHeight.value = window.innerHeight;
        getHeight()
    });
    setTimeout(() => {
        slideBanner()
    }, 2000);

});

onUpdated(() => {
    useHead({
        title: t('setup49') + `- ` + mateTitle.value,
        meta: [
            { name: 'description', content: mateTitle.value }
        ]
    });
})
//复制
const handleCopy = async (text) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            ElMessage({ type: 'success', message: t('cart74') });
        })
        .catch(err => {
            ElMessage({ type: 'error', message: t('cart75') });
        });
}
const drawer = ref(false)
const drawerClose = () => {
    drawer.value = false
}
const copyText = async () => {
    try {
        await navigator.clipboard.writeText(window.location.href);

        ElMessage({ type: 'success', message: t('cart74') });
    } catch (err) {
        ElMessage({ type: 'error', message: t('cart75') });
    }
}
const value = ref(4)
const checkedCount = ref([])
const checkItem = (groupIndex, itemIndex, check) => {
    if (check) {
        return
    } else {

            // 过滤出quantity不等于0的产品，并获取variant_names
            const nofilteredVariantNames = goods.value?.skus
                .filter(product => product.quantity != 0)
                .map(product => product.variant_names);
                console.log('不等于0的产品',nofilteredVariantNames)
                const uniqueVariantNames = nofilteredVariantNames.reduce((acc, current) => {
                return acc.concat(current);
            }, []).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            console.log('过滤重复值',uniqueVariantNames)
        console.log(groupIndex, itemIndex,check)
        //点击的规格值
        let checkData = goods.value?.variableAttr[groupIndex].values[itemIndex].name.zn
console.log('checkData',checkData)
        const filteredProducts = goods.value?.skus.filter(product =>
            product.variant_names.some(name => name === checkData)
        );
        console.log(filteredProducts);
        //判断选中
        for (let i = 0; i < goods.value?.variableAttr?.length; i++) {
            console.log(i, groupIndex)
            if (i == groupIndex) {
                console.log('点击选中')
                for (let z = 0; z < goods.value?.variableAttr[i].values.length; z++) {
                    goods.value.variableAttr[i].values[z].isDisabled = false
                    if (z == itemIndex) {
                        goods.value.variableAttr[i].values[z].check = true
                        console.log('点击选中',goods.value.variableAttr[i].values[z])

                    } else {
                         // 检查当前值是否在uniqueVariantNames数组中
                        if (uniqueVariantNames.includes(goods.value.variableAttr[i].values[z].name.zn)) {
                            console.log('存在')
                            goods.value.variableAttr[i].values[z].check = false
                        }else{
                            goods.value.variableAttr[i].values[z].check = false
                            goods.value.variableAttr[i].values[z].isDisabled = true
                        }
                       
                        console.log('点击选中1',goods.value.variableAttr[i].values[z])
                    }
                }
            } else {
               
                // 遍历products数组
                filteredProducts.forEach(product => {
                    // 找到values数组中与product.variant_names数组中任意元素相匹配的对象
                    const value = goods.value?.variableAttr[i].values.find(item =>
                        product.variant_names.some(name => name === item.name.zn)
                    );

                    if (value) {
                        // 根据quantity的值设置isDisabled属性
                        value.isDisabled = product.quantity === 0;
                    }
                });
                console.log('没选择',filteredProducts)
            }
        }
    }
    // 使用 map 和 filter 来提取所有 "check": true 的数据
    const filteredAttributes = goods.value?.variableAttr.map(attr => ({
        name: attr.name,
        values: attr.values.filter(val => val.check)
    }));
    console.log('filteredAttributes',goods.value?.variableAttr)
    // 过滤掉 values 为空的对象
    checkedCount.value = filteredAttributes.filter(attr => attr.values.length > 0);
    console.log('checkedCount.value', checkedCount.value)
    if (checkedCount.value?.length == goods.value?.variableAttr?.length) {
        // 提取SKUD选中的值
        const selectedValues = checkedCount.value.flatMap(attr =>
            attr.values.filter(val => val.check).map(val => val.name[languages.value] || val.name['en_us'])
        );
        console.log(selectedValues)
        const matchingProduct = goods.value?.skus.find(product => {
            // 检查 variant_names 是否包含 targetVariants 的所有元素
            return selectedValues.every(target => product.variant_names.includes(target));
        });
        console.log('对应的sku对象', matchingProduct)
        goods.value.price = matchingProduct.price
        maxNum.value = matchingProduct.quantity
        skuId.value = matchingProduct.id
        skuData.value = matchingProduct.sku
        inventory.value = matchingProduct.quantity
        // 提取颜色和尺寸的名称
        const extractedInfo = checkedCount.value.map(attr => {
            const value = attr.values.find(val => val.check);
            console.log('选中值', value)

            return value ? `${attr.name[languages.value] || attr.name['en_us']}：${value.name[languages.value] || value.name['en_us']}` : null;
        }).filter(info => info); // 过滤掉未找到匹配项的 null 值
        console.log(extractedInfo); // 输出: ["颜色:白色", "尺寸:L"]
        properties_name.value = extractedInfo.join('；');

    }
}
// 纵向滚动的距离
const { y } = useScroll(window)
const ydata = ref(-1)
const goBack = () => {
    routers.go(-1);
}
const ProductInfoDrawer = ref(false);
const checkImg = ref()
const submitBUT = (type) => {
    if (goods.value.variableAttr?.length != checkedCount.value?.length) {
        ProductInfoDrawer.value = true;
        checkImg.value = goods.value?.images[0]
    } else {
        if (type == 1) {
            addCart()//加入购物车
        } else {
            BuyitNowCart()//立即购买
        }
    }
}
</script>

<template>
    <div>

        <div class="xtx-goods-page" v-if="isMobile == false">

            <div class="container" v-if="goods" style="padding-top: 20px;">

                <!-- <div class="user pc">
                    <div class="userimg">
                        <div><img :src="goods.avatar" class="avatar"></div>
                        <div class="username" id="name">
                            <div>{{ maskName(`${goods.username}`) }}</div>
                            <div style="    display: flex;align-items: center;color: #FC7702;">
                                <el-rate style="--el-rate-disabled-icon-color: #f2cb0b;" v-model="value" disabled
                                    text-color="#FC7702" />
                                <div style="padding-left: 4px;"> 4.0</div>
                                <div class="line"></div>
                                <div class="fans">Fans：<span>{{ goods?.fansNum }}</span></div>
                                <div class="line"></div>
                                <div class="fans">Sold：<span>{{ goods?.salesSum }}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="attention" v-if="userStore.userInfo.id != goods.userId">
                        <div class="focuson" style="margin-right: 15px;" @click="goUser(goods.userId)">
                            <svg-icon icon-class="dianpu" style="width: 15px;height: 14px;margin-right: 3px;" />
                            {{ t('setup458') }}
                        </div>
                        <div class="focuson" @click="Addfollow(goods.userId)"
                            v-if="goods.isFollow == 1 || goods.isFollow == 0">
                            <svg-icon icon-class="focuson" style="width: 15px;height: 14px;margin-right: 3px;" />
                            {{ $t("home26") }}
                        </div>
                        <div class="focuson" @click="delfollow(goods.userId)" v-if="goods.isFollow == 2" style=" border: 1px solid #ef6052;color: #ef6052;">
                            <img src="../../assets/images/focusons.png" style="width: 16px;height: 14px;margin-right: 3px;" alt="" srcset="">
                          
                            {{ $t("home27") }}
                        </div>
                        <div style="display: flex;justify-content: space-between;margin-left: 15px;">

                            <el-tooltip :content="goods.telegram" placement="top" effect="customized"
                                v-if="goods.telegram">
                                <a :href="goods.telegram" target="_blank" rel="nofollow" class="button">
                                    <img src="../../assets/images/telegram.png"
                                        style="width: 41px;height: 41px;margin-right: 7px;" alt="" srcset="">
                                </a>
                            </el-tooltip>
                            <el-tooltip :content="goods.watchApp" placement="top" effect="customized"
                                v-if="goods.watchApp">
                                <a :href="goods.watchApp" target="_blank" rel="nofollow" class="button">
                                    <img src="../../assets/images/watch.png"
                                        style="width: 41px;height: 41px;border-radius: 50%;margin-left: 7px;" alt=""
                                        srcset="">
                                </a>
                            </el-tooltip>
                        </div>
                    </div>
                </div> -->
                <!-- 商品信息 -->
                <div class="info-container" ref="commodityElement" >
                    <div>
                        <div class="goods-info">
                            <div class="commodity" ref="goodsElement" id="goodsElement">
                                <div class="media">
                                    <!-- 图片预览区 -->
                                    <XtxImageView :imageList="imageListData" class="pc" />

                                </div>
                                <!-- 留言 -->
                                <!-- <div class="leaveComments">
                                <Evaluate :userid="userId"></Evaluate>

                            </div> -->

                                <!-- 商品详情 -->
                                <div class="title">
                                    <div class="name">{{ $t("setup49") }}</div>
                                </div>
                                <div class="detail-container" v-if="goods.description !== ''" style="width: 100%;">
                                    <ProductDetails @getHeight="getHeight" :description="goods.description"
                                        v-if="goods.description != ''">
                                    </ProductDetails>
                                </div>
                            </div>


                            <div class="spec pc" ref="specElement" id="specElement"
                            
                                :style="scrollHeight > 90 &&(goodsHeight > specHeight) && (scrollHeight < (commodityHeight - specHeight + 90)) ? `width:${specWidth}px;position: fixed;left: ${specLeft}px;z-index: 10;top:70px;` : scrollHeight >= (commodityHeight - specHeight + 90)&&(goodsHeight > specHeight) ? `position: absolute;left: 580px;bottom:0px;width:${specWidth}px` : `width:${specWidth}px`">
                                
                                <div class="specTop"></div>
                                <!-- 商品信息区 -->
                                <div class="specTitle">
                                    <div class="spec-name">
                                        {{ goods.name }}</div>
                                    <div @click="copyText()">
                                        <svg-icon icon-class="shares" style="width: 20px;height: 20px;" />
                                    </div>
                                </div>
                                <div class="info-Browse">
                                    <div class="Browse">{{ t('setup32') }} {{ goods.viewsNum }}</div>
                                    <!-- <div class="user-info-img" @click="goUser(goods.userId)">{{ t('setup482') }}:<img
                                            :src="goods.avatar" class="userimg"><svg-icon icon-class="yous"
                                            style="    margin-left: 4px;width: 6px;height: 10px;" /></div> -->
                                </div>
                                <!-- <p class="g-desc"> {{ goods.description }} </p> -->
                                <div class="info-price">
                                    <div class="price">
                                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                                        <span v-else>{{ exchangeRate(goods.price,
                                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                                    </div>
                                    <div class="liang">
                                        {{ $t('setup439') }}&nbsp;{{ goods.salesCount }}
                                    </div>
                                    <div class="liang">
                                        {{ $t('setup31') }} &nbsp;{{ inventory }}
                                    </div>
                                    <div class="liang">
                                        <span v-if="goods.needIntlPostage==false">{{$t('setup668')}}</span>
                                        <el-popover
                                        v-else
                                            class="box-item"
                                            :content="t('setup670')"
                                            placement="top-start"
                                        >
                                            <template #reference>
                                               <div> {{$t('setup669')}}<svg-icon icon-class="warning1" style="margin-top: -6px;position: absolute;"/> </div> 
                                            </template>
                                        </el-popover>
                                       
                                    </div>
                                   
                                </div>

                                <div class="hrdiv"></div>
                                <div class="sku" v-if="goods?.variableAttr?.length > 0">
                                    <div class="Specification" v-for="(item, index) in goods.variableAttr" :key="index">
                                        <div class="suktitle">

                                            {{ item.name[languages] || item.name['en_us'] }}

                                        </div>
                                        <div  class="skudata">
                                            <!-- 表示有图片 -->
                                            <div :class="[item.isImg && i.img ? i.check == true && i.isDisabled == false ? 'yesImgCheck' : 'yesImg':i.check == true && i.isDisabled == false ? 'noImgCheck' : 'noImg', i.isDisabled == true ? 'isDisabled' : '']"
                                                v-for="(i, indexs) in item.values" :key="indexs"
                                                @click="checkItem(index, indexs, i?.isDisabled); checkImg = i.img;">
                                                <div class="img" v-if="item.isImg&&i.img" ><img :src="i.img" alt="" srcset=""></div>
                                                <div class="imgname"> {{ i.name[languages] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="number">
                                    <span>{{ $t('cart29') }}：</span>
                                    <el-input-number v-model="num" :max="maxNum" class="mx-4" />
                                </div>
                                <!-- 按钮组件 -->
                                <div class="buts pc" v-if="userStore.userInfo.id != goods.userId">
                                    <div size="large"
                                        :class="[((goods.variableAttr?.length != checkedCount?.length ) && inventory!=0)||(goods.variableAttr?.length==0 && inventory==0) ? 'isDisabled' : '', 'addcart']"
                                        @click="addCart">
                                      
                                        {{ $t("home29") }}
                                    </div>
                                    <div size="large"
                                        :class="[((goods.variableAttr?.length != checkedCount?.length ) && inventory!=0)||(goods.variableAttr?.length==0&&inventory==0) ? 'isDisabled' : '', 'Buynow']"
                                        @click="BuyitNowCart();">
                                        {{ $t("home28") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="share" v-if="isMobile == true" @click="copyText()"
                            style="padding-bottom: 20px;padding-right: 20px;">
                            <svg-icon icon-class="share" style="width: 24px;height: 24px;" />{{ $t('setup99') }}
                        </div>
                    </div>


                </div>
                <div class="goods-footer">
                    <!-- 24热榜+专题推荐 -->
                    <div class="goods-aside" v-if="userStore.userInfo.token">
                        <!-- 24小时 -->
                        <DetailHot :hot-type="1" />

                    </div>
                </div>
            </div>
        </div>
        <div v-else class="phoneDIV">


            <div class="notopdiv" :class="{ show: y > 30 }" style="background: #fff;" v-if="y > 40">

                <div @click="goBack">
                    <img src="../../assets/images/return1.png"
                        style="width: 22px;height: 18px; background-color: #f4f5f700;" alt="" srcset="">
                </div>
                <div>
                    <img src="../../assets/images/collect1.png"
                        style="width: 26px;height: 26px; background-color: #f4f5f700;"
                        v-if="goods.isCollection == 1 || goods.isCollection == 0" alt="" srcset=""
                        @click="setCollect(goods.id)">
                    <img src="../../assets/images/collects1.png"
                        style="width: 26px;height: 26px; background-color: #f4f5f700;" alt="" srcset=""
                        @click="setDelCollect(goods.id)" v-if="goods.isCollection == 2">
                    <img src="../../assets/images/share1.png" alt="" style="width: 20px;height: 22px;margin-left: 8px;" class="img"
                        @click="copyText()">
                </div>
            </div>
            <div class="topdiv" :class="{ show: y < 40 }" v-else>

                <div @click="goBack">
                    <img src="../../assets/images/return.png" alt="" srcset="" class="img">
                </div>
                <div>
                    <img src="../../assets/images/collect.png" v-if="goods.isCollection == 1 || goods.isCollection == 0"
                        alt="" srcset="" class="img" @click="setCollect(goods.id)">
                    <img src="../../assets/images/collects.png" alt="" srcset="" class="img"
                        @click="setDelCollect(goods.id)" v-if="goods.isCollection == 2">
                    <img src="../../assets/images/share.png" alt="" style="margin-left: 8px;" class="img"
                        @click="copyText()">
                </div>
            </div>
            <div class="carousel">
                <!-- <div class="carousel-box" height="250px" pause-on-hover="true" interval="10000">
                    <div v-if="goods.video">
                        <video controls style="width: 100%;height: 100%;">
                            <source :src="goods.video" type="video/mp4">
                           {{ $t('setup497') }}
                        </video>
                    </div>
                    <div v-for="item in goods.images" :key="item">
                        <img :src="item" alt="" srcset="" style="object-fit: cover;">
                    </div>
                </div> -->
                <el-carousel height="250px" pause-on-hover="true" interval="10000" ref="slideCarousel">
                    <el-carousel-item v-if="goods.video">
                        <video controls style="width: 100%;height: 100%;">
                            <source :src="goods.video" type="video/mp4">
                            {{ $t('setup497') }}
                        </video>
                    </el-carousel-item>
                    <el-carousel-item v-for="item in goods.images" :key="item">
                        <img :src="item" alt="" srcset="" style="object-fit: cover;">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="ProductInfo">
                <div class="ProductInfo-title">{{ goods.name }}</div>
                <div class="info-Browse" style="        justify-content: space-between;align-items: center;">
                    <div class="Browse">{{ $t('setup32') }} {{ goods.viewsNum }}</div>
                    <!-- <div class="user-info-img" @click="goUser(goods.userId)">{{ $t('setup482') }}:<img :src="goods.avatar"
                            class="userimg"><svg-icon icon-class="yous"
                            style="    margin-left: 4px;width: 6px;height: 10px;" /></div> -->
                          <div class="liang" style="padding-right: 10px;    border: 1px solid #FC3938;
                            padding: 2px 5px;
                            border-radius: 8px;
                            background: #FEF1EA;
                            color: #FC3938;">
                        <span v-if="goods.needIntlPostage==false">{{$t('setup668')}}</span>
                        <el-popover
                        v-else
                            class="box-item"
                            :content="t('setup670')"
                            placement="top-start"
                        >
                            <template #reference>
                                <div> {{$t('setup669')}}<svg-icon icon-class="warning1" style="margin-top: -6px;position: absolute;"/> </div> 
                            </template>
                        </el-popover>
                    </div>
                </div>
                <div class="info-price">
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                        <span v-else>{{ exchangeRate(goods.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                    <div class="liang">
                        {{ $t('setup439') }}&nbsp;{{ goods.salesCount }}
                    </div>
                    <div class="liang">
                        {{ $t('setup31') }} &nbsp;{{ inventory }}
                    </div>
                  
                </div>
                <div class="hrdiv"></div>
                <div class="sku" v-if="goods?.variableAttr?.length > 0">
                    <div class="Specification" v-for="(item, index) in goods.variableAttr" :key="index">
                        <div class="suktitle">
                            {{ item.name[languages] || item.name['en_us'] }}
                        </div>
                        <div  class="skudata">
                            <!-- 表示有图片 -->
                            <div :class="[item.isImg && i.img ? i.check == true && i.isDisabled == false ? 'yesImgCheck' : 'yesImg':i.check == true && i.isDisabled == false ? 'noImgCheck' : 'noImg', i.isDisabled == true ? 'isDisabled' : '']"
                                v-for="(i, indexs) in item.values" :key="indexs"
                                @click="checkItem(index, indexs, i?.isDisabled); checkImg = i.img;">
                                <div class="img" v-if="i.img && item.isImg"><img :src="i.img" alt="" srcset=""></div>
                                <div class="imgname" v-else> {{ i.name[languages] }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="number">
                    <span>{{ $t('cart29') }}：</span>
                    <el-input-number v-model="num" :max="maxNum" class="mx-4" />
                </div>
            </div>
            <!-- <div class="ProductInfo-userInfo">
                <div class="userimg">
                    <div><img :src="goods.avatar" class="avatar"></div>
                    <div class="username" id="name">
                        <div>{{ maskName(`${goods.username}`) }}</div>
                        <div style="    display: flex;align-items: center;color: #FC7702;">
                            <svg-icon icon-class="slices" style="width: 18px; height: 17px;"></svg-icon>
                            <div style="padding-left: 4px;"> 4.0</div>
                            <div class="line"></div>
                            <div class="fans">Fans：<span>{{ goods?.fansNum }}</span></div>
                            <div class="line"></div>
                            <div class="fans">Sold：<span>{{ goods?.salesSum }}</span></div>
                        </div>
                    </div>
                </div>
                <div @click="goUser(goods.userId)">
                    <img src="../../assets/images/youbut.png" alt="" srcset=""
                        style="width: 7px;height: 12px;background-color: #f4f5f700;">
                </div>
            </div> -->
            <div class="ProductDetails">
                <div class="DetailsTitle">{{ $t("setup49") }}</div>
                <div class="Detailscontainer" style="width: 100%;">
                    <ProductDetails :description="goods.description" v-if="goods.description != ''"></ProductDetails>
                </div>
            </div>
            <div class="Product-footer">
                <div class="goods-aside" v-if="userStore.userInfo.token">

                    <DetailHot :hot-type="1" />

                </div>
            </div>
            <div class="goodsfixed">
                <div class="butdiv">
                    <div style="width: 70px;display: flex;align-items: center;justify-content: space-between;">
                        <div v-if="goods.watchApp">
                            <img @click="drawer = true" src="../../assets/images/watch.png"
                                style="width: 30px;height: 30px;border-radius: 50%;" alt="" srcset="">

                        </div>
                        <div v-if="goods.telegram">
                            <img @click="drawer = true" src="../../assets/images/telegram.png"
                                style="width: 30px;height: 30px;" alt="" srcset="">

                        </div>
                    </div>
                    <div v-if="userStore.userInfo.id != goods.userId" class="but">
                        <div size="large"   :class="[(inventory==0) ? 'isDisabled' : '', 'addcart']"
                        @click="submitBUT(1)">
                            {{ $t("home29") }}
                        </div>
                        <div size="large" :class="[(inventory==0) ? 'isDisabled' : '','Buynow']" @click="submitBUT(2)">
                            {{ $t("home28") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-model="loginModel" width="350" :before-close="handleClose" v-if="isMobile == false">
            <loginView :loginType="1" @close="handleClose" :type="1"></loginView>
        </el-dialog>
        <el-drawer v-else show-close :with-header="true" direction="btt" v-model="loginModel"
            :before-close="handleClose" size="70%">
            <loginView :loginType="1" @close="handleClose" :type="1"></loginView>
        </el-drawer>
        <el-drawer v-model="drawer" :title="t('cart23')" direction="btt" :before-close="drawerClose" size="25%">
            <div>
                <div v-if="goods.telegram">

                    <a :href="`${goods.telegram}`" target="_blank" rel="nofollow" class="button"
                        style="padding-right: 5px;">
                        <img src="../../assets/images/telegram.png" style="width: 20px;height: 20px;" alt="" srcset="">
                    </a>
                    {{ goods.telegram }}
                    <el-button type="warning" @click="handleCopy(goods.telegram)" size="small"
                        style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                </div>
                <div style="padding-top: 20px;" v-if="goods.watchApp">
                    <a :href="`${goods.watchApp}`" target="_blank" rel="nofollow" class="button"
                        style="padding-right: 5px;">
                        <img src="../../assets/images/watch.png"
                            style="width: 20px;height: 20px;border-radius: 50%;    " alt="" srcset="">
                    </a>

                    {{ goods.watchApp }}
                    <el-button type="warning" @click="handleCopy(goods.watchApp)" size="small"
                        style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                </div>
            </div>
        </el-drawer>
        <el-drawer v-model="ProductInfoDrawer" :with-header="false" direction="btt" :before-close="drawerClose"
            size="494px">
            <div class="closure" @click="ProductInfoDrawer = false">
                <img src="../../assets/images/closure.png" alt="" srcset="">
            </div>
            <div class="imgPrice">
                <img :src="checkImg" alt="" srcset="" style="width: 82px;height: 82px;">
                <div class="numprice">
                    <div class="name">
                        {{ goods.name }}
                    </div>
                    <div class="price">
                        <span v-if="userStore.exchangeRate.symbol == '￥'"> ¥{{ goods.price }}</span>
                        <span v-else>{{ exchangeRate(goods.price,
                            userStore.exchangeRate.symbol, userStore.exchangeRate.rate) }}</span>
                    </div>
                </div>
            </div>
            <div class="sku" v-if="goods?.variableAttr?.length > 0">
                <div class="Specification" v-for="(item, index) in goods.variableAttr" :key="index">
                    <div class="suktitle">
                        {{ item.name[languages] || item.name['en_us'] }}
                    </div>
                    <div  class="skudata">
                            <!-- 表示有图片 -->
                            <div :class="[item.isImg && i.img ? i.check == true && i.isDisabled == false ? 'yesImgCheck' : 'yesImg':i.check == true && i.isDisabled == false ? 'noImgCheck' : 'noImg', i.isDisabled == true ? 'isDisabled' : '']"
                                v-for="(i, indexs) in item.values" :key="indexs"
                                @click="checkItem(index, indexs, i?.isDisabled); checkImg = i.img;">
                                <div class="img" v-if="i.img && item.isImg"><img :src="i.img" alt="" srcset=""></div>
                                <div class="imgname" v-else> {{ i.name[languages] }}</div>
                            </div>
                        </div>
                </div>
            </div>
            <div class="number">
                <span>{{ $t('cart29') }}：</span>
                <el-input-number v-model="num" :max="maxNum" class="mx-4" />
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <div class="butdiv">
                        <div style="width: 70px;display: flex;align-items: center;justify-content: space-between;">
                            <div v-if="goods.watchApp">
                                <img @click="drawer = true" src="../../assets/images/watch.png"
                                    style="width: 30px;height: 30px;border-radius: 50%;" alt="" srcset="">
                            </div>
                            <div v-if="goods.telegram">
                                <img @click="drawer = true" src="../../assets/images/telegram.png"
                                    style="width: 30px;height: 30px;" alt="" srcset="">

                            </div>
                        </div>
                        <div v-if="userStore.userInfo.id != goods.userId" class="but">
                            <div size="large"
                                :class="[((goods.variableAttr?.length != checkedCount?.length ) && inventory!=0)||(goods.variableAttr?.length==0&&inventory==0) ? 'isDisabled' : '', 'addcart']"
                                @click="addCart">
                                {{ $t("home29") }}
                            </div>
                            <div size="large"
                                :class="[((goods.variableAttr?.length != checkedCount?.length ) && inventory!=0)||(goods.variableAttr?.length==0&&inventory==0) ? 'isDisabled' : '', 'Buynow']"
                                @click="BuyitNowCart();">
                                {{ $t("home28") }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </el-drawer>
    </div>
</template>

<style scoped lang='scss'>
.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: linear-gradient(90deg, rgb(159, 229, 151), rgb(204, 229, 129));
}

.el-popper.is-customized .el-popper__arrow::before {
  background: linear-gradient(45deg, #b2e68d, #bce689);
  right: 0;
}
.el-input-number__increase,
.el-input-number__decrease {

    background: #ffffff !important;
}

.el-rate {
    margin-left: -3px;
    height: 28px;
    // --el-rate-void-color: #dadee8;
    --el-rate-height: 20px;
    // --el-rate-font-size: var(--el-font-size-base);
    --el-rate-icon-size: 20px;
    --el-rate-icon-margin: -2px;
    // --el-rate-void-color: var(--el-border-color-darker);
    --el-rate-fill-color: #FC7702;
    // --el-rate-disabled-void-color: var(--el-fill-color);
    // --el-rate-text-color: var(--el-text-color-primary);
    /* 使用深度选择器 */
    // ::v-deep .el-rate__item.is-disabled.is-active {
    // background: none; /* 移除默认的背景 */
    // border: 1px solid #FC7702; /* 设置边框颜色 */
    // }
}


.pc {
    display: block;
}

.share {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    padding-top: 5px;
    background-color: #ffffff;
}

.xtx-goods-page {
    // background: #f5f5f5;

    .user {
        display: flex;
        align-items: center;
        padding: 21px 0;
        justify-content: space-between;
        background: #FFF;
        // margin: 15px 0;

        .userimg {
            display: flex;
            align-items: center;

            .avatar {
                // width: 50px;
                // /* 设置头像的宽度 */
                // height: 50px;
                // /* 设置头像的高度 */
                // border-radius: 50%;
                /* 使头像呈现圆形 */
                width: 48px;
                height: 48px;
                border-radius: 6px;
            }

            .username {
                margin-left: 15px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;

                .line {
                    width: 1px;
                    height: 11px;
                    border: 1px solid #D6D6D6;
                    margin: 0 10px;
                }

                .fans {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #888888;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;

                    span {
                        color: #333333;
                    }
                }
            }
        }

        .attention {
            display: flex;
            align-items: center;

            .focuson {
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                // font-weight: 600;

                height: 40px;
                background: #FFFFFF;
                border-radius: 20px;
                border: 1px solid #E1E1E1;
                padding: 0 38px;
            }

            .nofocuson {
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #f5f5f5;
                width: 100px;
                height: 30px;
                border-radius: 26px;
            }

            .connect {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                width: 90px;
                height: 30px;
                border-radius: 26px;
                background: #bbeafd;
            }
        }

    }

    .goods-info {
        min-height: 600px;
        background: #fff;
        display: flex;
        align-items: flex-start;

        position: relative;

        // overflow: hidden; /* 隐藏超出部分 */
        .commodity {
            width: 580px;

            // overflow-y: auto;
            // border: 1px solid #ccc;
            .media {
                // border: 1px solid;
                width: 580px;
                height: 480px;
                // padding: 30px 50px;

                .phone {
                    display: none;
                }

            }

            .leaveComments {
                padding-top: 160px;
                // margin: 30px 0;
            }
        }


        .spec {
            // width: 1200px;
            flex: 1;
            padding: 0 0 0 40px;
            // position: fixed;
            // top: 171px;
            /* 固定在顶部 */
            overflow-y: auto;
            height: auto;


            /* 允许垂直滚动 */
            // border: 1px solid #ccc;
            .specTop {
                width: 580px;
                height: 28px;
                background: #FC3938;
                border-radius: 4px;
            }

            .specTitle {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                margin-bottom: 16px;

                .spec-name {
                    width: 550px;
                    font-family: MicrosoftYaHei;
                    font-size: 20px;
                    color: #11192D;
                    line-height: 26px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .info-Browse {
                display: flex;

                .Browse {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #777777;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    padding-right: 18px;
                }

                .user-info-img {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #11192D;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    display: flex;
                    align-items: center;

                    .userimg {
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        margin-left: 5px;
                    }
                }
            }

            .info-price {
                display: flex;
                padding-top: 30px;
                align-items: center;
                margin-bottom: 25px;

                .price {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    // font-size: 15px;
                    font-size: 24px;
                    color: #FC3938;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                }

                .liang {
                    margin: 0 8px;
                    padding: 5px 8px;
                    background: #FEF1EA;
                    border-radius: 4px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #FC3938;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .hrdiv {
                width: 580px;
                height: 1px;
                border: 1px solid #E1E1E1;
                margin-bottom: 20px;
            }

            .sku {
                .Specification {
                    .suktitle {
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #11192D;
                        line-height: 21px;
                        text-align: left;
                        font-style: normal;
                        padding-bottom: 10px;
                    }

                    .skudata {
                        display: flex;
                        margin-bottom: 15px;
                        flex-wrap: wrap;
                        .noImg {
                            background: #FFFFFF;
                            border-radius: 16px;
                            border: 1px solid #E5E8EC;
                            padding: 6px 23px;
                            height: 32px;
                            margin-right: 15px;
                            margin-bottom: 10px;
                        }

                        .yesImg {
                            width: 88px;
                            height: 122px;
                            background: #FFFFFF;
                            border-radius: 8px;
                            border: 1px solid #E1E1E1;
                            margin-right: 8px;
                            margin-bottom: 5px;
                            .img {
                                width: 86px;
                                height: 94px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 8px 8px 0 0;
                                }

                            }

                            .imgname {
                                padding-top: 4px;
                                font-family: MicrosoftYaHei;
                                font-size: 12px;
                                color: #0F0F0F;
                                line-height: 12px;
                                text-align: left;
                                font-style: normal;
                                text-align: center;
                            }

                        }

                        .yesImgCheck {

                            width: 88px;
                            height: 122px;
                            background: #FFFFFF;
                            border-radius: 8px;
                            border: 1px solid #0F0F0F;
                            margin-right: 8px;

                            .img {
                                width: 86px;
                                height: 94px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 8px 8px 0 0;
                                }

                            }

                            .imgname {
                                padding-top: 4px;
                                font-family: MicrosoftYaHei;
                                font-size: 12px;
                                color: #0F0F0F;
                                line-height: 12px;
                                text-align: left;
                                font-style: normal;
                                text-align: center;
                            }
                        }

                        .noImgCheck {
                            padding: 6px 23px;
                            height: 32px;
                            background: #0F0F0F;
                            border-radius: 16px;
                            border: 1px solid #747474;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #FFFFFF;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                            margin-right: 15px;
                        }

                        .isDisabled {
                            cursor: not-allowed;
                            opacity: .3;
                        }
                    }

                }
            }

            .number {
                margin-bottom: 29px;
                display: flex;
                align-items: center;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;
            }

            .buts {
                .isDisabled {
                    cursor: not-allowed;
                    opacity: .3;
                }

                display: flex;
                font-family: MicrosoftYaHei,
                MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                justify-content: space-between;

                .addcart {
                    width: 280px;
                    height: 46px;
                    background: #FB7700;
                    border-radius: 23px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .Buynow {
                    width: 280px;
                    height: 46px;
                    background: #FC3938;
                    border-radius: 23px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                }
            }

            .user {
                display: flex;
                align-items: center;
                padding: 0px 10px 20px 10px;

                justify-content: space-between;

                .userimg {
                    display: flex;
                    align-items: center;

                    .avatar {
                        width: 50px;
                        /* 设置头像的宽度 */
                        height: 50px;
                        /* 设置头像的高度 */
                        border-radius: 50%;
                        /* 使头像呈现圆形 */
                    }

                    .username {
                        margin-left: 10px;
                        font-size: 16px;
                    }
                }

                .attention {
                    .focuson {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #f5f5f5;
                        width: 100px;
                        height: 39px;
                        border-radius: 26px;
                        font-size: 16px;
                        // font-weight: 600;
                    }

                    .nofocuson {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #f5f5f5;
                        width: 100px;
                        height: 30px;
                        border-radius: 26px;
                    }
                }

            }
        }


    }

    .title {
        margin-top: 50px;
        width: 580px;
        height: 68px;
        background: #F5F6F8;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #11192D;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        // padding: 25px 10px;margin-top: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        // border: 1px solid #eeeeee;
        // background: #e26237;
        // font-size: 16px;
        // color: #fff;
    }


    .goods-footer {
        display: flex;
        margin-top: 40px;

        .goods-article {
            width: 940px;
            margin-right: 20px;
        }

        .goods-aside {
            width: 100%;
            min-height: 1000px;
        }
    }

    .goods-tabs {
        min-height: 600px;
        background: #fff;
    }

    .goods-warn {
        min-height: 600px;
        background: #fff;
        margin-top: 20px;
    }

    .number-box {
        display: flex;
        align-items: center;

        .label {
            width: 60px;
            color: #999;
            padding-left: 10px;
        }
    }

    .g-name {
        font-size: 22px;
    }

    .g-desc {
        color: #999;
        margin-top: 10px;
    }

    .g-price {
        margin-top: 10px;

        span {
            &::before {
                // content: "¥";
                font-size: 14px;
            }

            &:first-child {
                color: $priceColor;
                margin-right: 10px;
                font-size: 22px;
            }

            // &:last-child {
            //     color: #999;
            //     text-decoration: line-through;
            //     font-size: 16px;
            // }
        }
    }



    .goods-sales {
        display: flex;
        width: 400px;
        align-items: center;
        text-align: center;
        height: 79px;

        li {
            flex: 1;
            position: relative;

            // ~li::after {
            //     position: absolute;
            //     top: 10px;
            //     left: 0;
            //     height: 60px;
            //     border-left: 1px solid #e4e4e4;
            //     content: "";
            // }

            p {
                &:first-child {
                    color: #999;
                }

                &:nth-child(2) {
                    color: $priceColor;
                    margin-top: 10px;
                }

                &:last-child {
                    color: #666;
                    margin-top: 10px;

                    i {
                        color: $xtxColor;
                        font-size: 14px;
                        margin-right: 2px;
                    }

                    &:hover {
                        color: $xtxColor;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

.nocollect {
    color: #b9b4b4;
}

.collect {
    color: #e26237;
}

.goods-tabs {
    min-height: 600px;
    background: #fff;

    nav {
        height: 70px;
        line-height: 70px;
        display: flex;
        border-bottom: 1px solid #f5f5f5;

        a {
            padding: 0 40px;
            font-size: 18px;
            position: relative;

            >span {
                color: $priceColor;
                font-size: 16px;
                margin-left: 10px;
            }
        }
    }
}

.goods-detail {
    padding: 40px;

    .attrs {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;

        li {
            display: flex;
            margin-bottom: 10px;
            width: 50%;

            .dt {
                width: 100px;
                color: #999;
            }

            .dd {
                flex: 1;
                color: #666;
            }
        }
    }

    >img {
        width: 100%;
    }
}

.btn {
    margin-top: 20px;

}

.bread-container {
    padding: 25px 0;
}

@media (max-width: 768px) {
    .phoneDIV {
        // padding-top: 60px;
        padding-bottom: 70px;
        background: #f4f5f7;

        .topdiv {
            left: 0;
            top: 0;
            z-index: 999;
            background-color: #fff;
            // border-bottom: 1px solid #e4e4e4;
            // 此处为关键样式!!!
            // 状态一：往上平移自身高度 + 完全透明
            transform: translateY(-100%);
            padding: 8px 15px 0 15px;
            display: flex;
            justify-content: space-between;
            justify-content: space-between;
            background-color: rgb(130 137 145 / 0%) !important;
            width: 100%;
            position: fixed;
            /* left: 0; */
            /* top: 0; */
            z-index: 999;

            .img {
                width: 28px;
                height: 28px;
                background-color: #f4f5f700 !important;

                img {
                    background-color: #f4f5f700;
                }
            }

            // 状态二：移除平移 + 完全不透明
            &.show {
                transition: all 0.3s linear;
                transform: none;
                opacity: 1;
                background-color: #ffffff;
            }
        }

        .notopdiv {
            height: 44px;
            left: 0;
            top: 0;
            z-index: 999;
            background-color: #fff;
            // border-bottom: 1px solid #e4e4e4;
            // 此处为关键样式!!!
            // 状态一：往上平移自身高度 + 完全透明
            transform: translateY(-100%);
            padding: 0px 20px 0 15px;
            display: flex;
            justify-content: space-between;
            justify-content: space-between;
            background-color: #fff !important;
            width: 100%;
            position: fixed;
            /* left: 0; */
            /* top: 0; */
            z-index: 999;
            display: flex;
            align-items: center;

            .img {
                width: 20px;
                height: 20px;
                background-color: #f4f5f700 !important;

                img {
                    background-color: #f4f5f700;
                }
            }

            // 状态二：移除平移 + 完全不透明
            &.show {
                transition: all 0.3s linear;
                transform: none;
                opacity: 1;
                background-color: #ffffff;
            }
        }
    }

    .demonstration {
        color: var(--el-text-color-secondary);
    }

    .carousel {
        img {
            width: 100%;
            height: 100%;
        }
    }

    // .carousel-box {
    //     width: 100%;
    //     height: 250px;
    //     display: flex;
    //     >div{
    //         width: 100%;
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }

    // }

    .ProductInfo {
        padding: 10px 15px 20px 15px;
        background: #ffffff;

        .ProductInfo-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            padding-bottom: 8px;
        }

        .info-Browse {
            display: flex;

            .Browse {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #777777;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                padding-right: 18px;
            }

            .user-info-img {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;

                .userimg {
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    margin-left: 5px;
                }
            }
        }

        .info-price {
            display: flex;
            padding-top: 30px;
            align-items: center;
            margin-bottom: 25px;

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                // font-size: 15px;
                font-size: 24px;
                color: #FC3938;
                line-height: 19px;
                text-align: left;
                font-style: normal;
            }

            .liang {
                margin: 0 8px;
                padding: 5px 8px;
                background: #FEF1EA;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FC3938;
                line-height: 16px;
                text-align: left;
                font-style: normal;
            }
        }

        .hrdiv {
            width: 100%;
            height: 1px;
            border: 1px solid #E1E1E1;
            margin-bottom: 20px;
        }

    }

    .ProductInfo-userInfo {
        margin-top: 10px;
        // padding-bottom: 100px;
        background: #ffffff;
        padding: 20px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .userimg {
            display: flex;
            align-items: center;

            .avatar {
                // width: 50px;
                // /* 设置头像的宽度 */
                // height: 50px;
                // /* 设置头像的高度 */
                // border-radius: 50%;
                /* 使头像呈现圆形 */
                width: 48px;
                height: 48px;
                border-radius: 6px;
            }

            .username {
                margin-left: 15px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;

                .line {
                    width: 1px;
                    height: 11px;
                    border: 1px solid #D6D6D6;
                    margin: 0 10px;
                }

                .fans {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #888888;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;

                    span {
                        color: #333333;
                    }
                }
            }
        }
    }

    .ProductDetails {

        // height: 42px;
        .DetailsTitle {
            padding: 9px 16px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
        }

        .Detailscontainer {
            background-color: #ffffff;
        }


    }

    .Product-footer {
        padding-top: 50px;
        background-color: #ffffff;

        // margin-top: 10px;
        .goods-aside {
            background-color: #ffffff;
        }
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #ededed;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #ededed;
    }

    .goodsfixed {
        width: 100%;

        width: 100%;
        height: 4.0625rem;
        position: fixed;
        padding: .625rem .8125rem;
        bottom: 0;
        z-index: 999;
        background-color: #fff;



        .nocollect {
            color: #b9b4b4;
        }

        .collect {
            color: #e26237;
        }


    }

    .butdiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 3.125rem;

        .connect {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 4.5625rem;
            height: 2.1875rem;
            border-radius: 1.625rem;
            background: #bbeafd;
            font-size: .875rem;
        }

        .but {
            display: flex;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.875rem;
            color: #FFFFFF;
            line-height: 1.25rem;
            text-align: left;
            font-style: normal;

            .addcart {
                // width: 142px;
                padding: 0 1.4375rem;
                height: 2.5rem;
                background: #FB7700;
                border-radius: 1.4375rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .Buynow {
                margin-left: .3125rem;
                padding: 0 1.4375rem;
                height: 2.5rem;
                background: #FC3938;
                border-radius: 1.4375rem;
                display: flex;
                justify-content: center;
                align-items: center;

            }
        }

    }

    .closure {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;

        img {
            width: 15px;
            height: 15px;
            background-color: #f4f5f700;
        }
    }

    .isDisabled {
        cursor: not-allowed;
        opacity: .3;
    }

    .sku {
padding-top: 16px;
        .Specification {
            .suktitle {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #11192D;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                padding-bottom: 10px;
            }

            .skudata {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 15px;

                .noImg {
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 1px solid #E5E8EC;
                    padding: 6px 23px;
                    height: 32px;
                    margin-right: 15px;
                    margin-bottom: 10px;

                }

                .yesImg {
                    width: 78px;
                    height: 78px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    border: 1px solid #E1E1E1;
                    margin-right: 8px;
                    margin-bottom: 5px;

                    .img {
                        height: 75px;
                        width: 75px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 8px 8px 8px 8px;
                        }

                    }

                    .imgname {
                        padding-top: 4px;
                        font-family: MicrosoftYaHei;
                        font-size: 12px;
                        color: #0F0F0F;
                        line-height: 12px;
                        text-align: left;
                        font-style: normal;
                        text-align: center;
                    }

                }

                .yesImgCheck {

                    width: 78px;
                    height: 78px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    border: 1px solid #0F0F0F;
                    margin-right: 8px;

                    .img {
                        width: 75px;
                        height: 75px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 8px 8px 8px 8px;
                        }

                    }

                    .imgname {
                        padding-top: 4px;
                        font-family: MicrosoftYaHei;
                        font-size: 12px;
                        color: #0F0F0F;
                        line-height: 12px;
                        text-align: left;
                        font-style: normal;
                        text-align: center;
                    }
                }

                .noImgCheck {
                    padding: 6px 23px;
                    height: 32px;
                    background: #0F0F0F;
                    border-radius: 16px;
                    border: 1px solid #747474;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                    margin-right: 15px;
                }

                .isDisabled {
                    cursor: not-allowed;
                    opacity: .3;
                }
            }

        }
    }

    .number {
        margin-bottom: 29px;
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #11192D;
        line-height: 21px;
        text-align: left;
        font-style: normal;
    }

    .imgPrice {
        height: 82px;
        display: flex;

        .numprice {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 10px;

            .name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #222222;
                line-height: 20px;
                text-align: left;
                font-style: normal;
            }

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                // font-size: 15px;
                font-size: 18px;
                color: #FC3938;
                line-height: 14px;
                text-align: left;
                font-style: normal;
            }
        }

    }

    // .container {
    //     width: 100%;
    //     padding-bottom: 50px;
    // }

    // .xtx-goods-page {
    //     width: 100%;
    //     margin-top: 50px;
    //     .goods-info{
    //         min-height: 300px;

    //     }
    //     .goods-sales {
    //         display: flex;
    //         width: 100%;
    //         align-items: center;
    //         text-align: center;
    //         height: 70px;

    //         li {
    //             flex: 1;
    //             position: relative;

    //             // ~li::after {
    //             //     position: absolute;
    //             //     top: 10px;
    //             //     left: 0;
    //             //     height: 60px;
    //             //     border-left: 1px solid #e4e4e4;
    //             //     content: "";
    //             // }

    //             p {
    //                 &:first-child {
    //                     color: #999;
    //                 }

    //                 &:nth-child(2) {
    //                     color: $priceColor;
    //                     margin-top: 10px;
    //                 }

    //                 &:last-child {
    //                     color: #666;
    //                     margin-top: 0px;

    //                     i {
    //                         color: $xtxColor;
    //                         font-size: 14px;
    //                         margin-right: 2px;
    //                     }

    //                     &:hover {
    //                         color: $xtxColor;
    //                         cursor: pointer;
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     .info-container {

    //         .goods-info {
    //             display: flex;
    //             flex-direction: column-reverse;

    //             .media {
    //                 width: 100%;
    //                 // height: 600px;
    //                 height:auto;
    //                 padding: 10px;

    //                 .image-container {
    //                     display: flex;
    //                     flex-wrap: wrap;
    //                     gap: 10px;
    //                     /* 图片之间的间隔 */
    //                     justify-content: center;
    //                     /* 图片居中显示 */
    //                 }

    //                 .image-container img {
    //                     width: 100%;
    //                     /* 第一张图片占满整行 */
    //                     // max-width: 50%;
    //                     /* 其他图片最大宽度为50%，以保证每行显示两张 */
    //                     height: auto;
    //                     /* 保持图片比例 */
    //                     flex-grow: 1;
    //                     /* 允许图片占据更多空间 */
    //                     flex-shrink: 1;
    //                     /* 当空间不足时，允许图片缩小 */
    //                 }

    //             }

    //             .spec {
    //                 padding: 10px;
    //             }
    //         }

    //         .pc {
    //             display: none;
    //         }
    //     }

    //     .goods-footer {
    //         margin-top: 5px;
    //         padding-bottom: 20px;

    //         .goods-article {
    //             width: 100%;
    //             margin-right: 20px;
    //         }

    //         .goods-aside {
    //             margin-bottom: 50px;
    //             width: 100%;
    //             // width: 280px;
    //             // min-height: 1000px;
    //         }

    //         flex-direction: column;
    //     }

    //     .g-name {
    //         font-size: 16px;
    //     }

    //     .g-desc {
    //         color: #999;
    //         margin-top: 10px;
    //     }
    //     .title{
    //     // padding: 25px 10px;margin-top: 25px;
    //     // display: flex;
    //     // align-items: center;
    //     // justify-content: space-between;
    //     // border: 1px solid #eeeeee;
    //     // background: #e26237;
    //     // font-size: 16px;
    //     // color: #fff;
    //     height: 42px;
    //     background: #e26237;
    //     color: #fff;
    //     font-size: 16px;
    //     line-height: 42px;
    //     padding-left: 10px;
    //     margin-bottom: 0px;
    //     font-weight: normal;
    // }
    //     .leaveComments {}
    // }






}
</style>